export enum PrimarySpecialty {
  PreOp = 'PRE_OP',
  PACU = 'PACU',
  OR = 'OR',
  Sedation = 'SEDATION',
}

export const PrimarySpecialtyLabel = {
  [PrimarySpecialty.PreOp]: 'Pre Op',
  [PrimarySpecialty.PACU]: 'PACU',
  [PrimarySpecialty.OR]: 'OR',
  [PrimarySpecialty.Sedation]: 'Sedation',
};

export const PrimarySpecialtyColors = {
  [PrimarySpecialty.PreOp]: '#7ED321',
  [PrimarySpecialty.PACU]: '#B057FF',
  [PrimarySpecialty.OR]: '#F55323',
  [PrimarySpecialty.Sedation]: '#F8E71C',
};

export enum Employment {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  PerDiem = 'PER_DIEM',
}

export const EmploymentLabel = {
  [Employment.FullTime]: 'Full Time',
  [Employment.PartTime]: 'Part Time',
  [Employment.PerDiem]: 'Per Diem',
};

export enum Compensation {
  Hourly = 'HOURLY',
  Annual = 'ANNUAL',
}

export const CompensationLabel = {
  [Compensation.Annual]: 'Annual',
  [Compensation.Hourly]: 'Hourly',
};

export enum OtherSpecialty {
  PreOp = 'PRE_OP',
  PACU = 'PACU',
  OR = 'OR',
  Sedation = 'SEDATION',
  Hours23 = 'HOURS23_STAY',
  OrthoSportMed = 'ORTHO_SPORTMED',
  OrthoJoint = 'ORTHO_JOINT',
  Spine = 'SPINE',
  Urology = 'UROLOGY',
  Gi = 'GI',
  Cv = 'CV',
  Ophthalmology = 'OPHTHALMOLOGY',
  Pain = 'PAIN',
  EntPlastic = 'ENT_PLASTIC',
}

export const OtherSpecialtyLabel = {
  [OtherSpecialty.PreOp]: 'Pre Op',
  [OtherSpecialty.PACU]: 'PACU',
  [OtherSpecialty.OR]: 'OR',
  [OtherSpecialty.Sedation]: 'Sedation',
  [OtherSpecialty.Hours23]: '23 Hours Stay',
  [OtherSpecialty.OrthoSportMed]: 'Ortho: SportMed / Gen',
  [OtherSpecialty.OrthoJoint]: 'Ortho: Joint',
  [OtherSpecialty.Spine]: 'Spine',
  [OtherSpecialty.Urology]: 'Urology',
  [OtherSpecialty.Gi]: 'GI',
  [OtherSpecialty.Cv]: 'CV',
  [OtherSpecialty.Ophthalmology]: 'Ophthalmology',
  [OtherSpecialty.Pain]: 'Pain',
  [OtherSpecialty.EntPlastic]: 'ENT / Plastic',
};

export enum Title {
  RegisteredNurse = 'REGISTERED_NURSE',
  LicensedVocationalNurse = 'LICENSED_VOCATIONAL_NURSE',
  ORTechnician = 'OR_TECHNICIAN',
  MedicalAssistant = 'MEDICAL_ASSISTANT',
  SterileProcessTechnician = 'STERILE_PROCESS_TECHNICIAN',
  OrthopedicTechnicianCertified = 'ORTHOPEDIC_TECHNICIAN_CERTIFIED',
}

export const TitleLabel = {
  [Title.RegisteredNurse]: 'Registered Nurse',
  [Title.LicensedVocationalNurse]: 'Licensed Vocational Nurse',
  [Title.ORTechnician]: 'OR Technician',
  [Title.MedicalAssistant]: 'Medical Assistant',
  [Title.SterileProcessTechnician]: 'Sterile Process Technician',
  [Title.OrthopedicTechnicianCertified]: 'Orthopedic Technician Certified',
};

export const TitleAbbreviationLabel = {
  [Title.RegisteredNurse]: 'RN',
  [Title.LicensedVocationalNurse]: 'LVN',
  [Title.ORTechnician]: 'ORT',
  [Title.MedicalAssistant]: 'MA',
  [Title.SterileProcessTechnician]: 'ST',
  [Title.OrthopedicTechnicianCertified]: 'OTC',
};

export default interface StaffMember {
  id?: number;
  hstId?: string;
  name?: string;
  phoneNumber?: string | null;
  email?: string | null;
  primarySpecialty?: PrimarySpecialty | null;
  otherSpecialties?: OtherSpecialty[] | null;
  title?: Title | null;
  employment?: Employment | null;
  compensation?: Compensation | null;
  hasScheduleAccess?: boolean;
  scheduleAccessAll?: boolean;
}
